import { Divider } from '@mui/material';
import { NavParentItem } from 'components/navigation/Components/NavItems/NavItem';
import React from 'react';
import { useStorage } from 'shared/hooks/useStorage';
import { localStorageItems } from 'utils/constants/localStorage';
import { featLoginWithCiamPing } from 'utils/feature-toggle/feat-login-with-ciam-ping';
import { EasyLogin } from './EasyLogin';
import { FeaturesToggler } from './FeaturesToggler';
import { MockSettings } from './Mock/MockSettings';
import { MockToggle } from './Mock/MockToggle';

const DevTools = () => {
  const [mockActive] = useStorage<boolean>(localStorageItems.enableMsw, true);
  return (
    <>
      {import.meta.env.MODE !== 'production' && (
        <NavParentItem icon='settings' text='Developer Tools' link='#' spinningIcon={false}>
          {!featLoginWithCiamPing() && <EasyLogin />}
          <MockToggle />
          <Divider />
          <FeaturesToggler />
        </NavParentItem>
      )}
      {mockActive && (
        <NavParentItem icon='notification' text='Mock settings' link='#' spinningIcon={false}>
          <MockSettings />
        </NavParentItem>
      )}
    </>
  );
};

export default DevTools;
